export const SSE_TEAL = "#0097A9";
export const SSE_TEAL_GRADIENT_FILL =
    "linear-gradient(to right bottom, #66c0cb, #0097A9)";

export const SSE_PRIMARY_DARK_BLUE = "#002D72";
export const SSE_PRIMARY_DARK_BLUE_GRADIENT_FILL =
    "linear-gradient(to right bottom, #002D72, #003586)";

export const SSE_GREY = "#425563";
